import React from 'react';
import ToolLayout from '../../components/ToolLayout';
import TextDiffCompare from '../../components/TextDiffCompare';

const DiffPage: React.FC = () => (
  <ToolLayout
    title="Text Diff Checker - Compare Text Online | AllTools"
    description="Compare two texts and find differences. Line-by-line diff with added and removed highlighting. Free tool."
    canonicalPath="/text-diff"
  >
    <TextDiffCompare />
  </ToolLayout>
);

export default DiffPage;
